import React, {useState, createContext, useRef} from 'react'
import * as journeyJson from "../../../static/journeyssr.json"
import * as lookup from "../../../static/lookup.json"
import * as lookupLang from "../../../static/journey_lookup.json"

export const JourneyContext = createContext()

export const JourneyProvider = (props) => {
    const[journeyState, setJourneyState] = useState({
        journeySteps: journeyJson.data.products[0].journeys[0],
        optionValues: {},
        allUniquePtValues: {},
        allUniquePptValues: {},
        lookup: lookupLang.en,
        policyTermLookup: lookup.policyTerm[0],
        policyTermLookupUpto35: lookup.policyTerm[0],
        productId: journeyJson.data.products[0].productId,
        planOption: journeyJson.data.products[0].planCode,
        journeyIdFromStrapi: journeyJson.data.products[0].journeys[0].journeyId,
        residenceDetailEmailTrigger: false,
        agentDetails: {
            "rmLedJourneyInd" : "00",
            "rmLedFNAInd": "N",
            "hsbcRMName" : "",
            "hsbcRMMobileNo" : "",
            "rmLedAgentId" : "",
            "hsbcRMEmailId" : "",
            "rmName" : "",
            "rmContactNo" : "",
            "rmLedAgentBRCode": "",
            "agentBankName": ""
        },
        fnaData: {},
        rmLedJourney: "N",
        channel: null,
        journeyId: null,
        lastPage: null,
        lastPageCode:null,
        lastSection: null,
        lastSectionCode: null,
        journeyCode: null,
        applicationNo: null,
        illustrationNumber: null,
        proposalEntryId: null,
        paymentDecryptData: null,
        premium: null,
        eSPCode: null,
        planName: null,
        subChannel: null,
        proposalFormLink: "",
        journeyData: [],
        paymentStep:"L",
        paymentFrequency: "01",
        ekycAuthType: "OM",
        gstWaiverInd:"N",
        titaniumBiKeys: {
            "projectedFundValue8Perc": "",
            "projectedFundValue4Perc": ""
        },
        gurantedSavingsBiKeys: {
           "premiumAmount": "",
           "gurantedSumAssured": "",
           "expectedBonusAmount": ""
        },
        journeyType: null,
        annualPremiumEquivalent : "",
        proceedWith : "",
        uid: "", // in case of redirect from website
        customerConsent: "N",
        redirectionTimeStamp:""
    })
    const isFirstProposalPageCovered2 = useRef(false)
    return (
        <JourneyContext.Provider value={[journeyState,setJourneyState,isFirstProposalPageCovered2]}>
            {props.children}
        </JourneyContext.Provider>
    )


}